import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';

export const projectHiddenModelsSelector = (projectId: string) =>
  createSelector(
    diagramSnapshotSelector(projectId),
    (diagram) => diagram?.model.modelData.hiddenModelIds
  );
